import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is a social media marketing service?",
    answer: `<p>Social media marketing service involves the <strong>use of social media platforms</strong>, where users build social networks and share information like Facebook, Instagram, TikTok, and others, to create brand awareness, increase sales, and drive traffic to your websites.</p>`,
  },
  {
    question: "How much does social media marketing cost?",
    answer: `<p>At an average, it costs around <strong>$1,500-$25,000 per month</strong> for a business to hire a social media marketing agency. However, it may differ from one agency to another.</p>`,
  },
  {
    question: "How much to hire a social media marketer?",
    answer: ` <p>It will cost  <strong>$300 to $800 per month</strong> to hire a social media marketer for basic services. To get advanced services with custom plans made for your business, it can go up to <strong>$800-$1200</strong>.</p>`,
  },
  {
    question: "Why should I use social media for my business?",
    answer: `<p>You need social media for your business because social media lets you <strong>share your brand's story</strong>, offering a deeper look into who you are and what you stand for.</p>`,
  },
  {
    question: "What Social media platforms should I sign up for?",
    answer: `<p>You have a variety of social media platforms to choose from: Facebook, Instagram, Snapchat, TikTok, Pinterest, Reddit, X (formerly known as Twitter), LinkedIn and YouTube.</p>`,
  },
  {
    question: "How often should I make posts on my social media platforms?",
    answer: ` <p>Here’s a rough breakdown of how many posts you can make on each platform:</p>
    <ul>
    <li><strong>Instagram:</strong> Post 1-2 posts a day.</li>
    <li><strong>Facebook:</strong> Post about once a day.</li>
    <li><strong>LinkedIn:</strong> Post between 3 to 5 times per week.</li>
    </ul>`,
  },
  {
    question:
      "How much should I spend on social media marketing, at an average?",
    answer: ` <p>At an average, you can spend  $15 to $200 per day to $450 to $6,000 per month on social media marketing.</p>`,
  },
  {
    question: "What is meant by promoted or boosted social media posts?",
    answer: `<p>Boosted social media posts are easy to create with just a few clicks, while other types of promoted social ads need a bit more setup to get started.</p>
    <p>However, regular social media ads agency tend to give you more options in terms of formats and objectives. Most businesses can benefit from using a mix of both boosted posts and social ads.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Social Media Marketing FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
